import { Component, ElementRef, Input, OnChanges } from '@angular/core';
import { TotemWidget } from '../totem-widget';
import { CurrentAirQualityData, CurrentWeatherData, ForecastWeatherData, WeatherService } from 'pg-lib/services/weather.service';
import { LocalizationService } from 'pg-lib/services/localization.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-totem-widget-weather',
    templateUrl: './totem-widget-weather.component.html',
    styleUrls: ['./totem-widget-weather.component.scss'],
    standalone: false
})
export class TotemWidgetWeatherComponent extends TotemWidget implements OnChanges {

    size:'md' = 'md'

    constructor(public elementRef:ElementRef, private weatherService:WeatherService, private domSanitizer:DomSanitizer, private localizationService:LocalizationService) {
        super(elementRef);
    }

    @Input() location:string;
    @Input() offset:number;

    currentWeatherData:CurrentWeatherData = null;
    currentAirQualityData:CurrentAirQualityData = null;

    forecastWeatherData:Array<ForecastWeatherData> = null;

    weatherGraphDataset

    ngOnChanges(): void {
        this.currentWeatherData = null;
        this.currentAirQualityData = null;
        this.weatherGraphDataset = null;

        if(this.location != null) {
            this.weatherService.getCurrentWeather(this.location).subscribe((data) => {
                this.currentWeatherData = data;

                let _coord = data.coord
                
                this.weatherService.getCurrentAirQuality(_coord.lat, _coord.lon).subscribe((data) => {
                    this.currentAirQualityData = data;
                })

                if(this.fullScreen || this.offset > 0) {
                    this.weatherService.getForecastWeather(this.location).subscribe((data) => {
                        this.forecastWeatherData = data;
                        
                        this.weatherGraphDataset = [];
    
                        for(let _cWeather of data[0].list) {
                            this.weatherGraphDataset.push({ 
                                value: _cWeather.getTemperature(), 
                                label: this.domSanitizer.bypassSecurityTrustHtml(new Date(_cWeather.dt * 1000).toISOString().split('T')[1].replace(/:[^:]*$/, '') +  _cWeather.getDisplay())
                            })
                        }
                    })
                }
            })
        }
    }

    getAirQualityIndex(data:CurrentAirQualityData) {
        if(data == null) return '';
        else {
            let _cSum = 0;

            for(let _cAq of data.list) {
                _cSum += _cAq.main.aqi;
            }
    
            return (_cSum / data.list.length).toFixed(1);
        }
    }

    formatLocation(location) {
        let _locationSplit = location.split(',')
        let _retVal = _locationSplit[0]

        if(_locationSplit.length > 2) {
            _retVal += ' (' + _locationSplit[1] + ')'
        }

        if(_locationSplit.length > 1) {
            _retVal += ' - ' + _locationSplit[_locationSplit.length - 1];
        }
        
        return _retVal;
    }

    getForecastDate(dayDiff:number) {
        let _nowDate = new Date();

        let _thenDate = new Date(_nowDate.getFullYear(), _nowDate.getMonth(), _nowDate.getDate() + dayDiff);

        let _retVal = '';

        if(dayDiff == 0) _retVal += this.localizationService.translate('pg-weather.today') + '<br/>'

        _retVal += this.localizationService.format.date(_thenDate, true, true);

        return _retVal;
    }
}
